import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useNavigate } from "react-router-dom";

import { useAuthUser } from "../../../hooks/AuthProvider";
import { logoutUser } from "../../../helpers/firebaseAuth";
import { useRoleContext, ROLE_LABELS, ROLE_ICONS, ROLE_HOMES } from "../../../context/RoleContext";
import UserAvatar from "../../Common/UserAvatar";

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false);

  const user = useAuthUser();
  const navigate = useNavigate();
  const username = user?.displayName || user?.email || "Guest";

  const { availableRoles, activeRole, setActiveRole } = useRoleContext();

  const handleRoleClick = (role) => {
    setMenu(false);
    setActiveRole(role);
    navigate(ROLE_HOMES[role]);
  };

  return (
    <Dropdown isOpen={menu} toggle={() => setMenu(!menu)} className="d-inline-block">
      <DropdownToggle className="btn header-item" id="page-header-user-dropdown" tag="button">
        <UserAvatar
          photoURL={user?.photoURL}
          name={user?.displayName}
          email={user?.email}
          className="rounded-circle header-profile-user"
          alt="Header Avatar"
        />
        <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
        <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem tag="a" href="/profile">
          <i className="bx bx-user font-size-16 align-middle me-1" />
          Profile
        </DropdownItem>
        {availableRoles.length > 1 && (
          <>
            <div className="dropdown-divider" />
            <div className="px-3 py-1">
              <small className="text-muted text-uppercase fw-semibold" style={{ fontSize: "0.7rem", letterSpacing: "0.05em" }}>
                Switch Role
              </small>
            </div>
            {availableRoles.map((role) => (
              <DropdownItem
                key={role}
                tag="button"
                onClick={() => handleRoleClick(role)}
                className={`d-flex align-items-center gap-2 ${activeRole === role ? "fw-semibold" : ""}`}
              >
                <i className={`${ROLE_ICONS[role]} font-size-16`} />
                {ROLE_LABELS[role]}
                {activeRole === role && (
                  <i className="bx bx-check ms-auto text-primary" />
                )}
              </DropdownItem>
            ))}
          </>
        )}

        <div className="dropdown-divider" />

        <DropdownItem tag="button" onClick={logoutUser} className="text-danger">
          <i className="bx bx-power-off font-size-16 align-middle me-1" />
          Logout
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

ProfileMenu.propTypes = {
  t: PropTypes.any,
};

export default ProfileMenu;

